import { Component, Input, Output, EventEmitter } from '@angular/core';

import { isNil } from 'lodash';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.scss'],
})
export class InputGroupComponent {
  @Input() value: any;
  @Input() unit: string = '';
  @Input() min: number = 0;
  @Input() max: number = 0;
  @Input() type = '';
  @Output() valueChange = new EventEmitter();

  isFocused = false;
  data: any;

  public checkForValue() {
    return !isNil(this.value);
  }

  public onBlur(value: any) {
    this.isFocused = false;
    this.value = value;
  }

  public onChange(newValue: any) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
